"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Hero = _interopRequireDefault(require("../../Hero/Hero"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FlexHero = function FlexHero(props) {
  var normalisedProps = _objectSpread(_objectSpread({}, props), {}, {
    bgImage: props.background,
    cta: props.button
  });
  return /*#__PURE__*/_react["default"].createElement(_Hero["default"], (0, _extends2["default"])({
    whiteFont: true,
    template: props.video.poster || props.mobile_video.poster ? 'Video' : 'Basic'
  }, normalisedProps));
};
FlexHero.propTypes = {
  background: _propTypes["default"].object.isRequired,
  video: _propTypes["default"].any,
  mobile_video: _propTypes["default"].any,
  poster: _propTypes["default"].any,
  title: _propTypes["default"].string,
  text: _propTypes["default"].string,
  subtitle: _propTypes["default"].string,
  trailer: _propTypes["default"].string,
  button: _propTypes["default"].object
};
var _default = exports["default"] = FlexHero;